// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"59d39f64","39":"301ad137","52":"23e40bb9","116":"16cc12cf","191":"ebe30456","339":"822675cb","405":"33a09c0f","439":"206183ad","459":"b6b8ac18","869":"d5c1971a","945":"b7163c77","970":"d3788670"}[chunkId] + ".chunk.js";
};